import { render } from "./InstallationImages.vue?vue&type=template&id=5c86d4fc"
import script from "./InstallationImages.vue?vue&type=script&lang=js"
export * from "./InstallationImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__